import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Modal as RNModal } from 'react-native';

interface PurchaseStoryModalProps {
  isVisible: boolean;
  onClose: () => void;
  onPurchase: () => void;
  title: string;
}

const PurchaseStoryModal: React.FC<PurchaseStoryModalProps> = ({
  isVisible,
  onClose,
  onPurchase,
  title
}) => {
  if (!isVisible) return null;

  return (
    <RNModal transparent={true} visible={isVisible} animationType="fade">
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <Text style={styles.modalTitle}>Purchase Completed Story</Text>
          <Text style={styles.modalDescription}>
            Download a PDF copy of "{title}". 
            {'\n\n'}
            Completed stories are only saved for 30 days!
          </Text>

          <TouchableOpacity style={styles.purchaseBtn} onPress={onPurchase}>
            <Text style={styles.purchaseBtnText}>Purchase PDF</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.cancelBtn} onPress={onClose}>
            <Text style={styles.cancelBtnText}>Cancel</Text>
          </TouchableOpacity>
        </View>
      </View>
    </RNModal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '90%',
    maxWidth: 400,
    backgroundColor: '#D9D9D9',
    borderRadius: 20,
    padding: 20,
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#160014',
    marginBottom: 10,
  },
  modalDescription: {
    fontSize: 14,
    color: '#534466',
    marginBottom: 20,
    textAlign: 'center',
  },
  purchaseBtn: {
    backgroundColor: '#534466',
    borderRadius: 15,
    paddingVertical: 10,
    paddingHorizontal: 20,
    width: 200,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    marginBottom: 10,
  },
  purchaseBtnText: {
    color: '#fff',
    fontSize: 14,
  },
  cancelBtn: {
    backgroundColor: '#544564',
    borderRadius: 15,
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginTop: 5,
    shadowColor: '#AFC9BF',
    shadowOpacity: 0.8,
    shadowRadius: 5,
  },
  cancelBtnText: {
    color: '#fff',
    fontSize: 14,
  },
});

export default PurchaseStoryModal;
